module.exports = __webpack_public_path__ + "img/interior-home-images-icon.91314de4.svg";